export default (...args) => window.documentViewer.loadDocument(...args);